// src/pages/Home/Components/HeroSection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Leaf } from 'lucide-react';
import woodImage from "../../../img/wood.webp";
import bannerImage from "../../../img/banner2.webp"; 
import bannerImage1 from "../../../img/banner1.webp";
import bannerImage2 from "../../../img/banner.webp";

function HeroSection() {
  const navigate = useNavigate();

  const handleShopClick = () => {
    navigate('/products');
  };

  return (
    <section className='flex flex-col justify-center items-center sm:flex-row gap-8 mt-4 px-3 z-0'>
      <article
        className='relative flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat rounded-2xl w-full sm:h-[353px] md:w-[778px] md:h-[435px] lg:h-[380px] min-h-[280px] p-3 md:p-8 overflow-hidden shadow-2xl shadow-[#9EAD8C]/20 transition-all duration-500 hover:shadow-[#9EAD8C]/30'
        style={{backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.85)), url(${woodImage})`}}
      >
        <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full blur-3xl" style={{ background: 'rgba(158, 173, 140, 0.1)' }} />
        <div className="absolute -bottom-20 -left-20 w-48 h-48 rounded-full blur-3xl" style={{ background: 'rgba(138, 154, 123, 0.1)' }} />
        
        <div className="relative z-10 w-full flex flex-col items-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 md:mb-6 rounded-full bg-[#9EAD8C]/10 backdrop-blur-sm border border-[#9EAD8C]/20 text-[#8A9A7B] text-[10px] md:text-xs font-medium self-center">
            <Leaf className="w-3.5 h-3.5" />
            <span className='font-bold'>اریس گالری</span>
          </div>

          <h2 className='font-bold text-xl sm:text-2xl md:text-[28px] text-center leading-snug text-gray-800'>
            زیبایی و اصالت چوب
            <span className='text-[#8A9A7B] block mt-1 sm:mt-0 sm:inline'> را به خانه بیاورید</span>
          </h2>

          <div className='font-light text-[12px] sm:text-[14px] md:text-[16px] w-[95%] sm:w-full text-center sm:text-right leading-7 md:leading-8 text-gray-600 mt-3 md:mt-5 space-y-1.5 sm:space-y-1'>
            <p>بعضی لحظه‌ها خیلی ساده‌اند؛ یک عصر آرام، چند نفر که دوستشان داریم و یک میز که دورش جمع شده‌ایم.</p>
            <p>اریس برای همین لحظه‌هاست؛ برای جزئیاتی که شاید کوچک باشند، اما حالِ خانه را تغییر می‌دهند.</p>
            <p className="font-medium text-gray-800">زیبا، کاربردی و ساخته‌شده برای زندگی.</p>
          </div>

          <button
            onClick={handleShopClick}
            className="group relative overflow-hidden rounded-xl text-white text-[13px] w-[148px] h-[35px] mt-5 md:mt-6
            sm:w-[137px] sm:h-[34px] md:text-[16px] md:w-[184px] md:h-[38px] md:text-[18px] transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg shadow-[#9EAD8C]/30"
            style={{ background: 'linear-gradient(135deg, #9EAD8C, #8A9A7B)' }}
          >
            <span className="relative text-sm z-10 flex items-center justify-center gap-2">
              مشاهده محصولات
              <ArrowLeft className="w-3 h-3 md:w-4 md:h-4 transition-transform duration-300 group-hover:-translate-x-1" />
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
          </button>
        </div>
      </article>

      <article className='flex flex-row gap-2 sm:gap-3 shrink-0'>
        <div className='flex flex-col gap-2 sm:gap-3'>
          <div className='relative w-[170px] h-[180px] sm:w-[120px] sm:h-[145px] md:w-[195px] md:h-[168px] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 group'
              style={{ background: 'linear-gradient(145deg, #9EAD8C, #8A9A7B)' }}>
            <div className="absolute inset-0 bg-cover bg-center opacity-20 group-hover:opacity-30 transition-opacity duration-500"
                style={{ backgroundImage: `url(${woodImage})` }} />
            <div className="absolute inset-0 bg-cover bg-center opacity-90 group-hover:opacity-100 transition-opacity duration-500"
                style={{ backgroundImage: `url(${bannerImage2})` }} />
            <div className="absolute inset-1.5 rounded-xl border-2 border-white/30 group-hover:border-white/50 transition-colors duration-300 pointer-events-none" />
          </div>
          
          <div className='relative w-[170px] h-[180px] sm:w-[120px] sm:h-[145px] md:w-[195px] md:h-[168px] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 group'>
            <img src={bannerImage} alt="بنر اریس گالری" className='w-full h-full object-cover transition-transform duration-700 group-hover:scale-110' />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            <div className="absolute inset-1.5 rounded-xl border-2 border-white/40 group-hover:border-white/60 transition-colors duration-300 pointer-events-none" />
            <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
              <span className="text-white text-xs font-medium block text-center">مجموعه بهار ۱۴۰۵</span>
            </div>
          </div>
        </div>
        
        <div className='relative w-[190px] h-[375px] sm:w-[160px] sm:h-[303px] md:w-[180px] md:h-[352px] lg:w-[210px] rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 group'
          style={{ background: 'linear-gradient(145deg, #9EAD8C, #8A9A7B)' }}>
        <div className="absolute inset-0 bg-cover bg-center opacity-10 group-hover:opacity-20 transition-opacity duration-500"
            style={{ backgroundImage: `url(${woodImage})` }} />
        <img 
          src={bannerImage1} 
          alt="بنر ویژه" 
          className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-500"
        />
        <div className="absolute inset-2 rounded-xl border-2 border-white/30 group-hover:border-white/50 transition-colors duration-300 pointer-events-none" />
        <div className="absolute inset-4 rounded-lg border border-white/20 group-hover:border-white/30 transition-colors duration-300 pointer-events-none" />
        <div className="absolute top-3 right-3 w-2 h-2 rounded-full bg-white/30 group-hover:bg-white/50 transition-colors duration-300" />
        <div className="absolute bottom-3 left-3 w-2 h-2 rounded-full bg-white/30 group-hover:bg-white/50 transition-colors duration-300" />
      </div>
      </article>
    </section>
  );
}

export default HeroSection;